export default __webpack_public_path__ + "static/media/globe.7a4113c7.png";